import 'twin.macro'

import { css } from '@emotion/react'
import { ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'

import Radio from '../Radio'

type RadioGroupProps<T extends number | string | undefined> = {
  groupName: string
  value?: T
  options:
    | Array<{
        value: T
        content: ReactNode
      }>
    | undefined
  twStyle?: TwStyle
  labelStyle?: TwStyle
  radioStyle?: TwStyle
  withoutSelectedBackground?: boolean
  withoutDivider?: boolean
  onChange: (option: T) => void
}

const labelStyles = (withoutDivider: boolean) => css`
  ${tw`flex items-center space-x-2 px-5 py-4 transition-colors cursor-pointer select-none`}
  ${!withoutDivider &&
  `:not(:first-of-type) {
    border-top: 1px solid var(--grey-stroke);
  }`}
`

const RadioGroup = <T extends number | string | undefined>({
  value,
  options,
  groupName,
  twStyle,
  radioStyle,
  labelStyle,
  withoutSelectedBackground,
  withoutDivider = false,
  onChange
}: RadioGroupProps<T>) => {
  return (
    <div css={[twStyle]}>
      {options?.map(option => {
        const isSelected = option.value === value
        return (
          <label
            key={option.value}
            css={[
              labelStyles(withoutDivider),
              withoutSelectedBackground ? null : isSelected && tw`bg-primary-alpha10`,
              labelStyle
            ]}
          >
            <Radio
              type='radio'
              css={[radioStyle]}
              value={option.value}
              checked={option.value === value}
              name={groupName}
              onChange={() => onChange(option.value)}
            />
            <div>{option.content}</div>
          </label>
        )
      })}
    </div>
  )
}

export default RadioGroup
